import type { ReactNode, ReactElement } from 'react';
import svg from '!!raw-loader!@search/metro/build/maps/msk.svg';

export default ({ children }: { children: (svg: ReactNode) => ReactElement }): ReactElement => {
    return children(svg);
};
